import ImagesUrl from "#constants/images.js";
import React from "react";

const CopeStageFileUpload = ({
  files,
  fileInputRef,
  handleFileChange,
  triggerFileInput,
  removeFile,
  placeholder,
  name,
  value,
  onChange,
  onBlur,
}) => {
  return (
    <div className="row mt-4">
      <div className="col-lg-6">
        <div className="common-modal-field">
          <label>Crop Stage</label>
          <div className="rate-input-field position-relative">
            <input
              type="text"
              className="form-control"
              placeholder={placeholder}
              name={name}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
            />
            <input
              type="file"
              className="d-none"
              accept="image/*"
              ref={fileInputRef}
              onChange={handleFileChange}
              multiple
            />
            <label>
              <span
                className="attach_file_icon_crop-stage "
                onClick={triggerFileInput}
              >
                <img src={ImagesUrl.attachIcon} alt="File" />
              </span>
            </label>
          </div>
        </div>
      </div>

      {/* {files.length > 0 && (
        <div className="col-12">
          <div className="file_preview_blk ">
            {files.map((file, index) => (
              <div key={index} className="file_preview_item">
                <div className="file_item_title">
                  {file?.name ? file.name : file.split("/").pop()}
                </div>
                <button
                  className="remove_file"
                  onClick={() => removeFile(index, file)}
                >
                  <img src={ImagesUrl.deleteIcon} alt="Trash" />
                </button>
              </div>
            ))}
          </div>
        </div>
      )} */}
      <div className="file_img_preview_wrapper">
        {files?.map((file, index) => (
          <div className="new_file_preview_item" key={index}>
            {file?.type ? (
              <img
                src={
                  file?.type === "application/pdf"
                    ? ImagesUrl.pdfIcon
                    : file?.type?.startsWith("image/")
                    ? URL.createObjectURL(file)
                    : ImagesUrl.defaultIcon
                }
                alt="Preview"
                height="100%"
                width="100%"
              />
            ) : (
              <img
                src={
                  file?.match(
                    /\.(jpeg|jpg|png|gif|jfif|webp|bmp|tiff|tif|svg|ico|heic|heif)$/i
                  )
                    ? file
                    : file?.match(/\.pdf$/i)
                    ? ImagesUrl.pdfIcon
                    : ImagesUrl.defaultIcon
                }
                alt="Preview"
              />
            )}
            <button
              className="remove_file"
              onClick={() => removeFile(index, file)}
            >
              <i className="fa fa-solid fa-xmark" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CopeStageFileUpload;
